<script>
	export let label = undefined;
	export let name;
	export let value = undefined;
	export let className = '';
	export let errors = [];
	export let inputClasses = '';
	export let style = '';
	export let prefix = undefined;
	export let suffix = undefined;
	export let labelClass = '';

	// eslint-disable-next-line no-unused-vars
	$: props = (({ label, name, value, className, inputClasses, errors, style, ...rest }) => rest)($$props);
</script>

<div class={'form-input-wrapper ' + className}>
	{#if label}
		<label class="form-label {labelClass}" for={name}>{label}</label>
	{/if}

	<div
		class="form-input-outer"
		class:disabled={props.disabled ?? false}
		class:placeholder={props.placeholder ?? false}
		class:readonly={props.readonly ?? false}
		{style}
	>
		{#if prefix}
			<div class="prefix">
				{prefix}
			</div>
		{/if}
		<input
			id={name}
			{name}
			bind:value
			on:change
			on:input
			on:keyup
			on:keydown
			on:focus
			{...props}
			class={'form-input-inner ' + inputClasses}
			class:error={errors && errors.length}
		/>
		{#if suffix}
			<div class="suffix">
				{suffix}
			</div>
		{/if}
	</div>
	{#if errors && errors.length}
		<div class="form-error">{errors[0]}</div>
	{/if}
</div>
